import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientList } from '~/features/ClientList';
import styles from './styles.module.scss';

/**
 * 利用企業一覧 Screen（新パターン）
 *
 * PageHeader（タイトル「利用企業」）と ClientList Feature を配置する。
 * ClientList の非同期処理は Suspense でラップし、ロード中は Loader を表示する。
 */
export const Screen: React.FC = () => (
  <>
    <PageHeader variant='title' title='利用企業' />
    <main className={styles.body}>
      <Suspense fallback={<Loader />}>
        <ClientList />
      </Suspense>
    </main>
  </>
);
